import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import type { SelectProps } from "@mui/material";
import { selectStyles, formControlStyles } from "../../utils/formStyles";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

interface BrandedSelectProps extends Omit<SelectProps, "variant"> {
  label: string;
  options: { label: string; value: string }[];
  helperText?: string;
  error?: boolean;
  fullWidth?: boolean;
}

export const BrandedSelect = ({
  label,
  options,
  helperText,
  error = false,
  fullWidth = true,
  ...props
}: BrandedSelectProps) => (
  <FormControl
    variant="standard"
    fullWidth={fullWidth}
    error={error}
    sx={formControlStyles}
  >
    <InputLabel>{label}</InputLabel>

    <Select
      sx={{
        ...selectStyles,
        "& .MuiSelect-icon": {
          transition: "transform 0.3s ease",
        },
        "&.Mui-focused .MuiSelect-icon": {
          transform: "rotate(180deg)",
        },
      }}
      IconComponent={KeyboardArrowDownRoundedIcon}
      {...props}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{ color: "#3f4e8c" }}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>

    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);